"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineDealerContextServices = exports.defineGfaDealerContextService = exports.defineDealerContextService = void 0;
const dealer_context_service_1 = require("./v1/dealer-context-service");
function defineDealerContextService() {
    return {
        id: 'dealer-context-service',
        dependencies: {},
        optionalDependencies: {
            featureServices: {
                's2:logger': '^1.0.0',
                'locale-service': '^1.0.0',
            },
        },
        create: ({ featureServices }) => {
            const { 's2:logger': logger = console } = featureServices;
            const localeService = featureServices['locale-service'];
            if (typeof window === 'undefined' || !window.sessionStorage) {
                logger.error(`Feature service ${defineDealerContextService().id} must not be used in SSR`);
                return undefined;
            }
            const featureService = dealer_context_service_1.DealerContextService(localeService);
            return {
                '1.0.0': () => ({ featureService }),
            };
        },
    };
}
exports.defineDealerContextService = defineDealerContextService;
function defineGfaDealerContextService() {
    return {
        id: 'gfa:dealer-context-service',
        dependencies: {
            featureServices: {
                'dealer-context-service': '^1.0.0',
            },
        },
        create: ({ featureServices }) => {
            const dealerContextService = featureServices['dealer-context-service'];
            return {
                '1.0.0': () => ({
                    featureService: dealerContextService,
                }),
            };
        },
    };
}
exports.defineGfaDealerContextService = defineGfaDealerContextService;
const defineDealerContextServices = () => [defineDealerContextService(), defineGfaDealerContextService()];
exports.defineDealerContextServices = defineDealerContextServices;
//# sourceMappingURL=feature-service.js.map